import { Actions } from './actions';
import {
  GET_SECURITY_LOADING_REPORTS_REQUEST,
  GET_SECURITY_LOADING_REPORTS_SUCCESS,
  GET_SECURITY_LOADING_REPORTS_ERROR,
} from './constants';
import { SecurityLoadingReport } from './interfaces';

export const initialState = {
  reports: [] as SecurityLoadingReport[],
  loading: false as boolean,
  error: null as null | Error,
};

export type SecurityLoadingReportState = typeof initialState;

export const reportLoadingReducer = (state: SecurityLoadingReportState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_SECURITY_LOADING_REPORTS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        reports: [],
      };
    }
    case GET_SECURITY_LOADING_REPORTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        reports: action.payload.reports,
      };
    }
    case GET_SECURITY_LOADING_REPORTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};
